import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const fullscreenModalContainer = css`
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  overflow: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${theme.zIndex.modals};

  :focus {
    outline: none;
  }
`;

export const fullscreenModalBody = css`
  flex: 1;
  overflow-y: auto;
  padding: ${theme.spacing(2)};
  text-align: left;

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.small};
  }
`;

export const fullscreenModalActions = css`
  position: relative;
  margin: auto;
  max-width: var(--fullscreen-modal-actions-max-width, none);
`;

export const fullscreenModalCloseButton = css`
  -webkit-app-region: none;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: ${theme.zIndex.low};
`;
